import React, { useState } from "react";
import { Button } from "@mui/material";
import { makeStyles } from "@mui/styles";

import { Menu, MenuItem, TextField } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { CustomTable } from "../../../components";
import { vendorManageInventory } from "../../../assets/lib/vendor";
import UpdateInventory from "./UpdateInventory";
import AddInventory from "./AddInventory";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Box from "@mui/material/Box";
import { useMediaQuery } from '@mui/material';

const customStyle = makeStyles({
  root: {
    padding: "20px 40px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "30px",
    overflow: "hidden",
    fontFamily:"montserrat"
  },
  '@media (max-width: 390px)': {
    root: {
      padding: "5px 10px",
      minWidth:"77%",
      display: "flex",
      flexDirection: "column",
      gap: "10px",
    },
  },
});

const Layout = (props) => {
  const {
    podMenu,
    podSelected,
    setPodSelected,
    itemsData,
    isTableLoading,
    currentPage,
    totalLength,
    handlePageChange,
    handlePageSize,
    handleSearchQuery,
    handleTableSorting,
    updateModalClicked,
    inventoryState,
    setIsModalOpen,
    isModalOpen,
    handleSubmitModal,
    getInventoryInput,
  

    isModalOpenForProduct,
    setIsModalOpenForProduct,
    productState,
    handleSubmitModalforProducts,
    getProductInput,
    productMenu,
    setProductMenu,
    productData,
    handledelete

  } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const classes = customStyle();
  const isPhone = useMediaQuery('(max-width: 390px)');

  const actions = [
    {
      label: "Update",
      onClick: (row) => {
        updateModalClicked(row);
      },
      bgColor: "#2196F3",
    },
  ];

  const onChangeMenuItem = (item) => {
    if (item !== podSelected) {
      setPodSelected(item);
      setAnchorEl(null);
    }
  };

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] =useState(15);


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return(
    <div className={classes.root}>
      <div>
        {!!podSelected && (
          <Button
            aria-controls="dropdown-menu"
            aria-haspopup="true"
            onClick={(event) => setAnchorEl(event.currentTarget)}
            variant="contained"
            color="primary"
            style={{ textTransform: "none", fontSize: isPhone? "10px":"16px" ,fontFamily:"montserrat",marginLeft:"-10px"}}
            endIcon={<KeyboardArrowDownIcon />}
          >
            {podSelected}
          </Button>
        )}
        <Menu
          id="dropdown-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
        >
          {podMenu.map((pod, index) => (
            <MenuItem onClick={() => onChangeMenuItem(pod)} key={index}>
              {pod}
            </MenuItem>
          ))}
          
        </Menu>
        <Button
            variant="contained"
            style={{
              color: "white",
              backgroundColor: "#FF5722",
              padding: "12px 24px",
              borderRadius: "10px",
              marginLeft:isPhone?"165px":"910px",
              fontSize: isPhone? "8px":"12px" ,
              marginTop:isPhone? "-50px":"inherit" ,
              fontFamily:"montserrat"
            }}
            onClick={() => {
              setIsModalOpenForProduct(true);
            }}
          >
            Add Product
          </Button>
      </div>
    <Paper  sx={{width: '100%',marginLeft: isPhone ? '-5px' : '-12px', marginTop: isPhone ? '-10px' : '-20px'}} >
       <Box height={20} />
      <TableContainer sx={{ maxHeight: 500,marginTop:"-20px" }}>
        <Table stickyHeader aria-label="sticky table" >
         <TableHead >
         <TableRow >
            <TableCell align="center" style={{ minWidth: "100px", backgroundColor:"rgb(178, 205, 243)",fontSize:isPhone?"12px":"inherit",fontFamily:"montserrat"}}>
             Product ID
             </TableCell>
             <TableCell align="center" style={{ minWidth: "100px", backgroundColor:"rgb(178, 205, 243)",fontSize:isPhone?"12px":"inherit",fontFamily:"montserrat"}}>
             Product Name
             </TableCell>
             <TableCell align="center" style={{ minWidth: "100px", backgroundColor:"rgb(178, 205, 243)",fontSize:isPhone?"12px":"inherit",fontFamily:"montserrat" }}>
             Price
             </TableCell>
             <TableCell align="center" style={{ minWidth: "100px", backgroundColor:"rgb(178, 205, 243)",fontSize:isPhone?"12px":"inherit",fontFamily:"montserrat"}}>
             Quantity
             </TableCell>
             <TableCell align="center" style={{ minWidth: "100px", backgroundColor:"rgb(178, 205, 243)",fontSize:isPhone?"12px":"inherit",fontFamily:"montserrat" }}>
             Expiry
             </TableCell>
             <TableCell align="center" style={{ minWidth: "100px", backgroundColor:"rgb(178, 205, 243)",fontSize:isPhone?"12px":"inherit",fontFamily:"montserrat"}}>
              Action
             </TableCell>
         </TableRow>
       </TableHead>
        <TableBody>
        {itemsData

          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row) => {
             return (
               <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                <TableCell  align="center" style={{fontSize:isPhone?"10px":"inherit",fontFamily:"montserrat"}}>
                      {row.productId}
                     </TableCell>
                     <TableCell  align="center" style={{fontSize:isPhone?"10px":"inherit",fontFamily:"montserrat"}} >
                      {row.productName}
                     </TableCell>
                     <TableCell align="center" style={{fontSize:isPhone?"10px":"inherit",fontFamily:"montserrat"}}>
                      {row.unitPrice}
                     </TableCell>
                     <TableCell  align="center" style={{fontSize:isPhone?"10px":"inherit",fontFamily:"montserrat"}}>
                     {row.quantity}
                     </TableCell>
                     <TableCell align="center" style={{fontSize:isPhone?"10px":"inherit",fontFamily:"montserrat"}}>
                    {row.expiry}
                     </TableCell>
                     <TableCell align="center" style={{fontSize:isPhone?"10px":"inherit",fontFamily:"montserrat"}}>
                        {actions.map((action, index) => (
                          <Button
                            // className={classes.viewButton}
                            align="center"
                            variant="contained"
                            onClick={() => action.onClick(row)}
                            style={{ backgroundColor: action.bgColor, fontSize:isPhone?"10px":"inherit",fontFamily:"montserrat" }}
                            key={index}
                          >
                            {action.label}
                          </Button>
                        ))}
                      <Button
                      align="center"
                        variant="contained"
                        style={{
                          color: "white",
                          backgroundColor: "#FF5722",
                          borderRadius: "4px", 
                          marginLeft:isPhone?"0px":"10px",
                          fontSize:isPhone?"10px":"inherit",
                          marginTop:isPhone?"5px":"inherit",
                          fontFamily:"montserrat"
                        }}
                        onClick={() => {
                          handledelete(row);
                        }}
                      >
                        Delete
                      </Button>
                     </TableCell>
                  </TableRow>
                );
              })
              } 
          </TableBody>   
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[15,25,35]}
        component="div"
        count={itemsData.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>

      <UpdateInventory
        isModalOpen={isModalOpen}
        updateModalClicked={updateModalClicked}
        inventoryState={inventoryState}
        setIsModalOpen={setIsModalOpen}
        handleSubmitModal={handleSubmitModal}
        getInventoryInput={getInventoryInput}

        productMenu={productMenu}
        setProductMenu={setProductMenu}
        productData={productData}

      />
      <AddInventory
        isModalOpenForProduct={isModalOpenForProduct}
        setIsModalOpenForProduct={setIsModalOpenForProduct}
        productState={productState}
        handleSubmitModalforProducts={handleSubmitModalforProducts}
        getProductInput={getProductInput}
        productMenu={productMenu}
        setProductMenu={setProductMenu}
        productData={productData}

      />
    </div>
    
  );
};

export default Layout;
